// jQuery(function ($) {
//     var fadeIn = $('.fade-in');
//     $(window).scroll(function () {
//       $(fadeIn).each(function () {
//         var offset = $(this).offset().top;
//         var scroll = $(window).scrollTop();
//         var windowHeight = $(window).height();
//         if (scroll > offset - windowHeight + 50) {
//           $(this).addClass("scroll-in");
//         }
//       });
//     });
//   });

jQuery(function ($) {
  var fadeIn = $('.fade-in');
  $(window).scroll(function () {
    $(fadeIn).each(function () {
      var offset = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();

      if (scroll > offset - windowHeight + 50) {
        var $element = $(this);

        if ($element.hasClass('scroll-slow')) {
          setTimeout(function () {
            $element.addClass("scroll-in");
          }, 500);
        } else if ($element.hasClass('scroll-slow06')) {
          setTimeout(function () {
            $element.addClass("scroll-in");
          }, 600);
        } else if ($element.hasClass('scroll-slow07')) {
          setTimeout(function () {
            $element.addClass("scroll-in");
          }, 700);
        } else if ($element.hasClass('scroll-slow08')) {
          setTimeout(function () {
            $element.addClass("scroll-in");
          }, 800);
        } else if ($element.hasClass('scroll-slow09')) {
          setTimeout(function () {
            $element.addClass("scroll-in");
          }, 900);
        } else if ($element.hasClass('scroll-slow10')) {
          setTimeout(function () {
            $element.addClass("scroll-in");
          }, 1000);
        } else if ($element.hasClass('scroll-slow11')) {
          setTimeout(function () {
            $element.addClass("scroll-in");
          }, 1100);
        } else if ($element.hasClass('scroll-slow12')) {
          setTimeout(function () {
            $element.addClass("scroll-in");
          }, 1200);
        } else if ($element.hasClass('scroll-slow13')) {
          setTimeout(function () {
            $element.addClass("scroll-in");
          }, 1300);
        } else if ($element.hasClass('scroll-slow14')) {
          setTimeout(function () {
            $element.addClass("scroll-in");
          }, 1400);
        } else if ($element.hasClass('scroll-slow15')) {
          setTimeout(function () {
            $element.addClass("scroll-in");
          }, 1500);
        }else if ($element.hasClass('scroll-slow16')) {
          setTimeout(function () {
            $element.addClass("scroll-in");
          }, 1600);
        }
        else if ($element.hasClass('scroll-slow17')) {
          setTimeout(function () {
            $element.addClass("scroll-in");
          }, 1700);
        }
        else if ($element.hasClass('scroll-slow18')) {
          setTimeout(function () {
            $element.addClass("scroll-in");
          }, 1800);
        }
        else if ($element.hasClass('scroll-slow19')) {
          setTimeout(function () {
            $element.addClass("scroll-in");
          }, 1900);
        }
        else if ($element.hasClass('scroll-slow20')) {
          setTimeout(function () {
            $element.addClass("scroll-in");
          }, 2000);
        }else {
          // それ以外の要素は即座にクラスを追加
          $element.addClass("scroll-in");
        }
      }
    });
  });
});



  jQuery(window).on('load', function() {
    setTimeout(function() {
      $('.fade-in-first').addClass('scroll-in'); }, 500);
  });
